<!-- eslint-disable vue/max-len -->
<template>
  <svg
    v-if="direction === 'up'"
    v-bind="$attrs"
    :class="`sort-arrow-up color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 20V6.875L7.5625 10.5625L6.5 9.5L12 4L17.5 9.5L16.4375 10.5625L12.75 6.875V20H11.25Z"
    />
  </svg>
  <svg
    v-else
    v-bind="$attrs"
    :class="`sort-arrow-down color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 20L6.5 14.5L7.5625 13.4375L11.25 17.125V4H12.75V17.125L16.4375 13.4375L17.5 14.5L12 20Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
  direction: 'up' | 'down';
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
